export const addCommas = (nStr) => {
  if (nStr !== 0 && nStr !== null) {
    let parts = nStr.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    parts[1] = parseFloat("0." + parts[1])
      .toFixed(2)
      .replace("0.", "");
    return parts.join(".");
    // nStr = String(nStr).replace(".", ",");

    // nStr += "";
    // var x = nStr.split(",");
    // var x1 = x[0];
    // const x3 =
    //   String(x[1]).length >= 2
    //     ? String(x[1]).slice(0, 2)
    //     : String(x[1]).length == 1 && String(x[1]) + "0";
    // var x2 = x.length > 1 ? "," + x3 : ",00";
    // var rgx = /(\d+)(\d{3})/;
    // // while (rgx.test(x1)) {
    // //   x1 = x1.replace(rgx, "$1" + " " + "$2");
    // // }
    // console.log("x1,x2", x1, x2);
    // return x1 + x2;
  } else {
    return "";
  }
};
export const removeCommas = (str) => {
  return typeof str === "string"
    ? Number(parseFloat(str.replace(/\s|\s+/g, "").replace(",", ".")))
    : typeof str === "number" && str !== "" && Number(str);
};
